import { computationOptions } from "#app/computationOptions";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { QuoteRequestDto } from "#modules/quoteRequests/infra/fetchQuoteRequest.api";
import {
  computeQuoteRequestPrice,
  OptimizedMachineTimes,
  OptimizedMaterialCosts,
  ProcessStep,
} from "shared";

type Params = {
  quoteRequest: QuoteRequestDto;
  quoteRequestProcessSteps: ProcessStep[];
  quoteRequestLines: QuoteRequestLineDto[];
  salesMarginRatio: number;
  discountRatio: number;
  optimizedMachineTimes: OptimizedMachineTimes;
  optimizedMaterialCosts: OptimizedMaterialCosts;
};

export const computeQuoteRequestTotals = ({
  quoteRequest,
  quoteRequestProcessSteps,
  quoteRequestLines,
  salesMarginRatio,
  discountRatio,
  optimizedMachineTimes,
  optimizedMaterialCosts,
}: Params) =>
  computeQuoteRequestPrice(
    {
      quoteRequest: {
        ...quoteRequest,
        salesMarginRatio,
        discountRatio,
        quoteRequestLines,
        processSteps: quoteRequestProcessSteps.map((processStep) => ({
          ...processStep,
          materialLayout: null,
          productLines: [],
        })),
        productLines: [],
      },
      isQuotePrice: true,
      optimizedMachineTimes,
      optimizedMaterialCosts,
    },
    computationOptions,
  );
